import { CommApiInstance } from "Utils/CommApiInstance";

const MembOtpRegApi = async (
    otpAthnNo:string,
    otpScrt: string,
) => {
    return await CommApiInstance.post(`memb/otp/reg`,{
        apiBody:{
            otpAthnNo:otpAthnNo,
            otpScrt:otpScrt,
        },
    })
    .then((Resp) => Resp.data);
}
export default MembOtpRegApi;